<template>
    <div>
        <advertisement v-if="advert !== null" :advert="advert" :loading-message="LoadingDescription"
                       :user-selection="UserSelection" screen="Performing Analysis" />
        <loading-control v-if="IsLoading" :loading-message="LoadingDescription" />
        <div v-if="UserSelection.externalChanged" class="right">
            <p>
                Ooops, it looks as though you have changed the {{UserSelection.externalChanged}} within UnderwriteMe.
                If you would like to run a ProtectionGuruPro comparison on this basis, you will need to restart the analysis.
            </p>
            <el-button type="primary" @click="GoHome()"> Go back to ProtectionGuruPro </el-button>
        </div>
        <div v-if="UserSelection.externalMessage" class="right">
            <p> {{UserSelection.externalMessage}} </p>
            <el-button type="primary" @click="GoHome()"> Go back to ProtectionGuruPro </el-button>
        </div>
        <div v-else>
            <div class="analysisCard" v-if="Analysis !== null && IsLoading === false && !UserSelection.isPending && !UserSelection.externalChanged && !UserSelection.externalMessage">
                <div class="left">
                    <div class="results">
                        <div class="clientDetails">
                            <div style="display:inline-flex">
                                <div class="labels">
                                    Policy details
                                </div>
                                <div class="links" v-if="!isViewingAsOther && UserDetails.pricingWebID !== null">
                                    <el-link v-on:click.stop="$emit('edit-policy')" class="summaryLabels"
                                             style="text-decoration: underline">Edit</el-link>
                                </div>
                            </div>
                            <div class="detailsItem"
                                 v-if="UserSelection.primaryClient !== null && UserSelection.selectedCustomerType != null">
                                <div class="detailsLabel"> Name: </div>
                                <div class="detailsList">
                                    {{UserSelection.primaryClient.forename + " " +
                                    UserSelection.primaryClient.surname}}
                                </div>
                            </div>
                            <div class="detailsItem" v-if="UserSelection.secondaryClient !== null">
                                <div class="detailsLabel"></div>
                                <div class="detailsList">
                                    {{UserSelection.secondaryClient.forename + " " +
                                    UserSelection.secondaryClient.surname}}
                                </div>
                            </div>
                            <div class="detailsItem" v-if="UserSelection.policyTerm !== null">
                                <div class="detailsLabel"> Term length: </div>
                                <div class="detailsList">{{ UserSelection.policyTerm }}</div>
                            </div>
                            <div class="detailsItem" v-if="UserSelection.toAge !== null">
                                <div class="detailsLabel"> To Age: </div>
                                <div class="detailsList">{{ UserSelection.toAge }}</div>
                            </div>
                            <div class="detailsItem">
                                <div class="detailsLabel"> Benefit basis: </div>
                                <div class="detailsList">{{ UserSelection.ipBenefitBasis }}</div>
                            </div>
                            <div class="detailsItem" v-if="UserSelection.ipBenefitBasis === 'Monthly'">
                                <div class="detailsLabel"> Benefit Amount: </div>
                                <div class="detailsList">&pound;{{ UserSelection.ipBenefitAmount }}</div>
                            </div>
                            <div class="detailsItem">
                                <div class="detailsLabel">In. deferred period: </div>
                                <div class="detailsList">{{ deferredPeriod[UserSelection.ipInitialDeferredPeriod] }}</div>
                            </div>
                            <div class="detailsItem">
                                <div class="detailsLabel">Indexation: </div>
                                <div class="detailsList">{{ UserSelection.ipIndexation }}</div>
                            </div>
                            <div class="detailsItem" v-if="UserSelection.ipAdditionalDeferredPeriod != null">
                                <div class="detailsLabel">Add. deferred period: </div>
                                <div class="detailsList">{{ convertAddDeferredPeriod(UserSelection.ipAdditionalDeferredPeriod) }}</div>
                            </div>
                            <div class="detailsItem" v-if="UserSelection.ipAdditionalDeferredBenefitAmount != null">
                                <div class="detailsLabel"> Add. benefit amount: </div>
                                <div class="detailsList">&pound;{{ UserSelection.ipAdditionalDeferredBenefitAmount }}</div>
                            </div>
                            <div class="detailsItem" v-if="UserSelection.ipIndexation !== 'Level'">
                                <div class="detailsLabel"> Benefit Increase: </div>
                                <div class="detailsList" v-if="UserSelection.ipBenefitIncreaseBasis == 'PolicyInception'"> Policy Inception</div>
                                <div class="detailsList" v-else> On claim </div>
                            </div>
                        </div>

                        <div class="customizeResult"
                             :style="UserSelection.ipBenefitBasis === 'Monthly' ? 'top:209px;' : 'top:179px;'">
                            <div class="labels" style="width:251px"> Customize your results </div>
                            <div class="clientBudget">
                                <label class="labels" style="line-height:24px">Client budget</label>
                                <span class="budget">
                                    <el-input v-model="UserSelection.clientBudget" type="number" class="input-number" />
                                </span>
                            </div>
                        </div>
                        <div>
                            <el-checkbox v-model="RemoveNotInBudget" label="Remove products not in budget"
                                         class="checkboxLabel "
                                         :disabled="UserSelection.clientBudget === null || UserSelection.clientBudget <= 0"></el-checkbox>
                        </div>

                        <div v-if="Analysis !== null && IsLoading === false" class="premiumTypeDetails" style="margin-top:16px">
                            <div v-if="UserSelection.underwritten">
                                <div class="labels"> Underwriting </div>
                                <el-checkbox-group v-model="AnalysisUMEFilter">
                                    <!-- <el-checkbox label="STANDARD">Buy now</el-checkbox>
                                    <el-checkbox label="NON_STANDARD">Buy now non-standard</el-checkbox> -->
                                    <el-checkbox label="EVIDENCE_REQUIRED">Evidence Required</el-checkbox>
                                    <el-checkbox label="REFER">Referred</el-checkbox>
                                    <el-checkbox label="POSTPONE">Can't offer cover now</el-checkbox>
                                    <el-checkbox label="DECLINE">Can't offer cover</el-checkbox>
                                </el-checkbox-group>
                                <el-checkbox-group v-model="AnalysisUMEExclusionFilter">
                                    <el-checkbox label="EXCLUSION">Exclusion</el-checkbox>
                                </el-checkbox-group>
                            </div>

                            <div class="labels"> Premium Type </div>
                            <el-checkbox-group v-model="AnalysisPremiumTypeFilter">
                                <el-checkbox value="Guaranteed" label="Guaranteed"></el-checkbox>
                                <el-checkbox value="Guaranteed_AgeCosted" label="Guaranteed_AgeCosted">
                                    Guaranteed - Age
                                    Costed
                                </el-checkbox>
                                <el-checkbox value="Reviewable" label="Reviewable"></el-checkbox>
                                <el-checkbox value="Reviewable_AgeCosted" label="Reviewable_AgeCosted">
                                    Reviewable - Age
                                    Costed
                                </el-checkbox>
                            </el-checkbox-group>
                            <div class="labels" style="margin-top:16px"> Benefit period </div>

                            <el-checkbox-group :size="'mini'" v-model="AnalysisBenefitTypeFilter">
                                <el-checkbox value="_1_Year_Benefit_Period" label="_1_Year_Benefit_Period">
                                    1 Year Benefit
                                    Period
                                </el-checkbox>
                                <el-checkbox value="_2_Year_Benefit_Period" label="_2_Year_Benefit_Period">
                                    2 Year Benefit
                                    Period
                                </el-checkbox>
                                <el-checkbox value="_5_Year_Benefit_Period" label="_5_Year_Benefit_Period">
                                    5 Year Benefit
                                    Period
                                </el-checkbox><br />
                                <el-checkbox value="Full_Term" size="small" label="Full_Term">Full Term</el-checkbox>
                            </el-checkbox-group>
                        </div>

                        <div style="margin-left:16px" v-for="(filter, filterIndex) in Analysis.providerFilters" :key="filterIndex">
                            <div class="labels" style="margin-top:16px;width:100%;"> {{ filter.name }} </div>
                            <div style="margin-top:5px;" :title="filter.description"
                                 v-for="option in filter.providerFilterOptions" :key="option.reference">
                                <el-checkbox v-model="SelectedCustomFilterOptionKeys" :label="option.reference"
                                             :value="option.reference" :id="'option' + option.reference">
                                    <label :for="'option' + option.reference" title="" style="height:0px !important">
                                        {{ option.option }}
                                    </label>
                                </el-checkbox>
                            </div>
                        </div>

                        <div class="providersList" v-if="AllUniqueResultProviders.length > 0">
                            <div class="labels" style="margin-top:16px"> Providers </div>
                            <div v-for="provider in AllUniqueResultProviders" :key="provider">
                                <el-checkbox v-model="SelectedProviders" :label="provider">
                                </el-checkbox>
                            </div>
                        </div>

                        <div class="navigationbtn">
                            <button
                                    v-if="!isViewingAsOther && UserSelection.underwritten == null && userDetails.integrations?.some(i => i === 'UNDERWRITEME')"
                                    class="ume"
                                    @click="UserSelection.pgpLinkedAnalysisReference ?
                                    helper.OpenNewTab(UserSelection.pgpLinkedAnalysisReference) :
                                    (UserSelection.umeLinkedAnalysisReference ? helper.OpenUrl(UserSelection.umeLinkedAnalysisReference) : ConvertFromIpipelineToUME())">
                                <span v-if="UserSelection.pgpLinkedAnalysisReference">Retrieve underwritten quotes</span>
                                <span v-else>Get fully underwritten quotes from:</span>
                                <img src="../assets/images/underWriteMeLogo5.png" alt="Imagen">
                            </button>

                            <el-button type="success" v-if="Analysis !== null && IsLoading === false"
                                       @click="IsCancel = IsRequestingReport = true"
                                       :disabled="isViewingAsOther || UserDetails.pricingWebID === null || !isValidCustomer || (FilteredProducts?.length ?? 0) === 0">Download Report</el-button>
                            <br />
                            <el-button type="default" v-if="Analysis !== null && IsLoading === false"
                                       @click="IsShowDownloadIllustration = true"
                                       :disabled="isViewingAsOther || UserDetails.pricingWebID === null">Download Illustration</el-button>
                            <br />
                            <el-button type="default" v-if="Analysis !== null && IsLoading === false && CanApply" @click="IsApplyNow = true"
                                       :disabled="isViewingAsOther || UserDetails.pricingWebID === null">Apply Now</el-button>
                            <br />
                            <el-button type="default"
                                       v-if="UserSelection.expressTemplate !== null && IsLoading === false && UserSelection.legacyPolicyProviderReference === ''"
                                       @click="$emit('amend-quality-analysis')" :disabled="isViewingAsOther || UserDetails.pricingWebID === null">
                                Amend
                                analysis
                            </el-button>
                        </div>

                        <LeftPanelReferences></LeftPanelReferences>

                        <pricing-report-details v-if="IsRequestingReport === true && IsLoading === false"
                                                :user-selection="UserSelection" :user-details="UserDetails" :analysis="Analysis"
                                                v-on:generate-report="DownloadPDFReport" v-on:generate-short-report="DownloadPDFShortReport"
                                                v-on:report-details-cancelled="IsCancel = IsRequestingReport = false" :current-analysis="Analysis"
                                                :chart-data="OverallChartData" :chart-data-headings="MainChartAdditionalHeadings"
                                                :compare-selection="CompareSelection" />

                        <!--Added Download Illustration modal here based on Apply Now Modal-->
                        <download-illustration v-if="IsShowDownloadIllustration === true && IsLoading === false"
                                               v-on:download-illustration="DownloadIllustrations"
                                               v-on:cancelled="IsShowDownloadIllustration = false" :chart-data="OverallChartData"
                                               :chart-data-headings="MainChartAdditionalHeadings" :user-selection="UserSelection" />

                        <apply-now-modal v-if="IsApplyNow === true && IsLoading === false" v-on:apply-now="ApplyNow"
                                         v-on:cancelled="IsApplyNow = false" :chart-data="PurchasableItems"
                                         :chart-data-headings="MainChartAdditionalHeadings" />

                        <analysis-breakdown v-if="ShowAnalysisBreakdown === true && IsLoading === false"
                                            @closed="ShowAnalysisBreakdown = false" :extended-features="UserSelection.extendedFeatures"
                                            :analysis="Analysis" :provider-selection="SelectedProducts" />
                    </div>
                </div>

                <div class="right">
                    <div style="display:inline-flex">
                        <div class="count"> {{ MainChartData.items.length }} results</div>
                        <div style="float:right;">
                            <el-radio-group v-model="Filter" size="medium" style="display:inline-flex">
                                <el-radio-button class="radioText" label="All"></el-radio-button>
                                <el-radio-button class="radioText"
                                                 :disabled="UserSelection.clientBudget === null || UserSelection.clientBudget <= 0"
                                                 label="Best quality in budget"></el-radio-button>
                                <el-radio-button class="radioText"
                                                 :disabled="UserSelection.clientBudget === null || UserSelection.clientBudget <= 0"
                                                 label="In budget"></el-radio-button>
                                <el-radio-button class="radioText" label="Lowest premium"></el-radio-button>
                            </el-radio-group>
                        </div>
                    </div>
                    <br />
                    <div>
                        <!--<el-input v-model="FilterIPAnalysis" placeholder="Type to search for and or compare providers" class="SearchCustomers" prefix-icon="el-icon-search" />-->
                        <el-select v-model="CompareSelection" popper-class="SearchProductsPopper"
                                   placeholder="Type to search for and/or compare products" class="SearchCustomers" :multiple-limit="3"
                                   prefix-icon="el-icon-search" filterable multiple>
                            <el-option-group label="Best in quality">
                                <el-option v-for="(cdi) in MainChartData.items.filter(function (a) { return a.values[0].DisplayValues[a.values[0].DisplayValues.length - 1].BestQuality; })"
                                           :value="cdi.values[0].Reference" :key="'BestQuality' + cdi.values[0].Reference"
                                           style="height:50px;" :label="cdi.values[0].Label">
                                    <el-image :src="cdi.values[0].Logo" style="width:40px;height:40px;vertical-align:bottom;"
                                              fit="contain"></el-image>
                                    {{ cdi.values[0].Label }}
                                </el-option>
                            </el-option-group>
                            <el-option-group label="Best quality in budget">
                                <el-option v-for="(cdi) in MainChartData.items.filter(function (a) { return a.values[0].DisplayValues[a.values[0].DisplayValues.length - 1].BestInBudget; })"
                                           :value="cdi.values[0].Reference" :key="'BestInBudget' + cdi.values[0].Reference"
                                           style="height:50px;" :label="cdi.values[0].Label">
                                    <el-image :src="cdi.values[0].Logo" style="width:40px;height:40px;vertical-align:bottom;"
                                              fit="contain"></el-image>
                                    {{ cdi.values[0].Label }}
                                </el-option>
                            </el-option-group>
                            <el-option-group label="Lowest premium">
                                <el-option v-for="(cdi) in MainChartData.items.filter(function (a) { return a.values[0].DisplayValues[a.values[0].DisplayValues.length - 1].LowestPremium; })"
                                           :value="cdi.values[0].Reference" :key="'LowestPremium' + cdi.values[0].Reference"
                                           style="height:50px;" :label="cdi.values[0].Label">
                                    <el-image :src="cdi.values[0].Logo" style="width:40px;height:40px;vertical-align:bottom;"
                                              fit="contain"></el-image>
                                    {{ cdi.values[0].Label }}
                                </el-option>
                            </el-option-group>
                            <el-option-group label="In budget">
                                <el-option v-for="(cdi) in MainChartData.items.filter(function (a) { return a.values[0].DisplayValues[a.values[0].DisplayValues.length - 1].InBudget; })"
                                           :value="cdi.values[0].Reference" :key="'InBudget' + cdi.values[0].Reference"
                                           style="height:50px;" :label="cdi.values[0].Label">
                                    <el-image :src="cdi.values[0].Logo" style="width:40px;height:40px;vertical-align:bottom;"
                                              fit="contain"></el-image>
                                    {{ cdi.values[0].Label }}
                                </el-option>
                            </el-option-group>
                            <el-option-group label="All Products">
                                <el-option v-for="(cdi) in MainChartData.items" :value="cdi.values[0].Reference"
                                           :key="cdi.values[0].Reference" style="height:50px;" :label="cdi.values[0].Label">
                                    <el-image :src="cdi.values[0].Logo" style="width:40px;height:40px;vertical-align:bottom;"
                                              fit="contain"></el-image>
                                    {{ cdi.values[0].Label }}
                                </el-option>
                            </el-option-group>
                        </el-select>
                    </div>
                    <div v-if="Analysis !== null && IsLoading === false">
                        <div class="orderBy">
                            <div>
                                <label class="allresults">All results (Click on a product to compare in more detail)</label>
                            </div>
                            <div>
                                <el-select style="border:none !important" v-model="IsPricing" label="sort by:"
                                           placeholder="Sort by">
                                    <el-option label="Order by quality" :value="false"></el-option>
                                    <el-option label="Order by price" :value="true"></el-option>
                                    <el-option v-if="this.UserSelection.ipBenefitBasis === 'Maximum'" label="Order by maximum benefits" :value="'maxBenefits'"></el-option>
                                </el-select>
                            </div>
                        </div>

                        <div class="AllData">
                            <!--<span>
                                <collapsable-bar-chart max-selection="3" :selection="CompareSelection" :title="IsPricing ? 'Pricing': 'Quality Score'" :chart-data="SelectedMainChartData" :expanded-keys="ExpandedProviders" :alternate-value-title="MainChartAdditionalHeadings" :user-selection="UserSelection" :analysis="Analysis" />
                            </span>-->
                            <span>
                                <collapsable-bar-chart max-selection="3" chart-type="Selected" @compare="PerformComparison"
                                                       :selection="CompareSelection" :title="IsPricing ? 'Pricing' : 'Quality Score'"
                                                       :chart-data="SelectedMainChartData" :expanded-keys="ExpandedProviders"
                                                       :alternate-value-title="MainChartAdditionalHeadings" :user-selection="UserSelection"
                                                       :analysis="Analysis" :is-comparing="IsComparing" />
                            </span>
                            <span>
                                <collapsable-bar-chart max-selection="3" chart-type="Unselected" :selection="CompareSelection"
                                                       :title="IsPricing ? 'Pricing' : 'Quality Score'" :chart-data="UnselectedMainChartData"
                                                       :expanded-keys="ExpandedProviders" :alternate-value-title="MainChartAdditionalHeadings"
                                                       :user-selection="UserSelection" :analysis="Analysis" />
                            </span>
                            <!--<div v-if="CompareSelection.length > 0" class="bottomHugging">
                                <button class="compare" @click="PerformComparison">Analyse Selected Products</button>
                            </div>-->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
    .SearchProductsPopper .el-select-dropdown__wrap {
        max-height: 400px;
    }

    .maxWidth .el-select div {
        width: unset !important;
    }

    .el-select__tags {
        display: flex !important;
        top: 40% !important;
    }

    .el-collapse-item__header {
        /*display: flex !important;*/
    }

    .el-collapse {
        border-top: none !important;
        border-bottom: none !important;
    }
</style>
<style scoped>
    .el-button:not(.is-text, .is-link, .el-button--text) {
        border-color: none !important;
        /*border: none !important;*/
    }

    .el-radio-button__inner:hover {
        color: black;
    }

    /*.el-checkbox__input.is-checked .el-checkbox__inner {
        width: 24px !important;
        height: 24px !important;
    }

    .el-checkbox__inner, .el-checkbox__inner, .el-checkbox__inner::after {
        width: 24px !important;
        height: 24px !important;
    }

    .el-checkbox.is-bordered.el-checkbox--medium .el-checkbox__inner {
        height: 24px !important;
        width: 24px !important;
    }

    .el-checkbox__input {
        width: 24px !important;
        height: 24px !important;
    }

    .el-checkbox__inner {
        width: 24px !important;
        height: 24px !important;
    }*/
    span .el-checkbox__inner {
        width: 24px !important;
        height: 24px !important;
    }

    .el-select-dropdown__item.selected {
        color: black;
        font-weight: 700;
    }

    /*.el-input__inner {
        border-color: black !important;
    }

        .el-input__inner:hover {
            border-color: black;
        }*/


    .analysisCard {
        display: flex;
        max-width: 1144px !important;
        min-width: 1144px !important;
        width: 100% !important;
        margin-left: auto !important;
        margin-right: auto !important;
        border-radius: 8px;
        padding: 24px;
    }

    .orderBy {
        justify-content: space-between;
        display: inline-flex;
        align-items: flex-start;
        padding: 0px;
        position: static;
        width: 775px;
    }

    .card {
        margin-left: 350px;
    }

    .el-link.el-link--default:hover {
        color: black !important;
    }

    .el-link.is-underline:hover:after {
        border: none;
    }

    .el-link.el-link--default:after {
        border: none;
    }

    .btnQuality {
        justify-content: center;
        align-items: center;
        padding: 5px;
        position: static;
        width: max-content !important;
        background: none;
        height: 40px;
        left: 199px;
        top: 0px;
        border-radius: 8px;
    }

    .radioText {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 56px;
        display: flex;
        align-items: center;
        text-align: center;
        letter-spacing: -0.04em;
        color: #4B5768;
    }

    .monthlyBenefit {
        position: inherit;
        width: 100px;
        left: 422px;
        margin-left: 15px;
    }

    .price {
        position: inherit;
        width: 80px;
        left: 422px;
        margin-left: 15px;
    }

    .qualityScore {
        position: inherit;
        width: 150px;
        left: 200px;
        margin-left: 35px;
    }

    .links {
        text-decoration: underline;
        font-family: 'Inter';
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
    }

    .title {
        position: relative;
        height: 34px;
        left: 150px;
        top: 150px;
        font-family: 'Inter';
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 41px;
        display: flex;
        align-items: center;
        letter-spacing: -0.04em;
        color: #000000;
    }

    .results {
        width: 317px;
        left: 150px;
        top: 129px;
        background: #FFFFFF;
        border-radius: 8px;
    }

    .clientDetails {
        padding: 16px;
        position: relative;
        width: 285px;
        height: 225px;
        left: 0px;
        top: 0px;
        background-color: #F7F8F9;
        border-radius: 8px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .labels {
        position: inherit;
        height: 80px;
        position: static;
        width: 150px;
        height: 28px;
        left: 0px;
        top: 0.5px;
        font-family: 'Inter';
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 19px;
        display: flex;
        align-items: center;
        color: #323A46;
    }

    .links {
        position: static;
        width: 109px;
        height: 28px;
        left: 176px;
        top: 0.5px;
        font-family: 'Inter';
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 41px;
        display: flex;
        align-items: center;
        text-align: right;
        letter-spacing: -0.04em;
        text-decoration-line: underline;
        color: #323A46;
        margin-left: 85px;
    }

    .detailsLabel {
        width: 149px;
        font-family: 'Inter';
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 8px;
        display: inline-block;
        align-items: center;
        color: #A0ABBB;
    }

    .detailsList {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 8px;
        /* or 57% */
        display: inline-block;
        align-items: center;
        /* Neutral/700 */
        color: #323A46;
        margin-left: 12px
    }

    .customizeResult {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding-left: 15px;
        position: static;
        width: 285px;
        left: 16px;
        top: 197px;
    }

    .clientBudget {
        position: static;
        width: 280px;
        left: 0px;
        top: 39px;
    }

    .el-input {
        /*  position: absolute;
        width: 280px;
        height: 44px;
        left: 20px;
        background: #FFFFFF;*/
    }

    /*.el-checkbox__inner {
        width: 24px !important;
        height: 24px !important;
        border-radius: 4px;
        display: inline-block;
        position: relative;
        border: 1px solid #dcdfe6;
        box-sizing: border-box;
        background-color: #fff;
        z-index: 1;
        transition: border-color .25s cubic-bezier(.71, -.46, .29, 1.46),background-color .25s cubic-bezier(.71, -.46, .29, 1.46);
    }*/

    .checkboxLabel {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 8px;
        align-items: center;
        color: #323A46;
        padding-left: 10px;
        left: 10px;
    }

    .premiumTypeDetails {
        position: static !important;
        width: 285px !important;
        left: 16px !important;
        top: 100px !important;
        padding-left: 15px !important;
    }

    .providersList {
        position: static !important;
        width: 285px !important;
        left: 16px !important;
        top: 100px !important;
        padding-left: 15px !important;
    }

    .navigationbtn {
        /*margin-top: 50px !important;*/
        padding: 16px !important;
    }

    .el-checkbox__input.is-checked + .el-checkbox__label {
        color: #323A46;
    }

    .el-button--success {
        color: #fff !important;
        background-color: #1E228C !important;
        /*border-color: none !important;*/
        margin-top: 25px !important;
    }

    .el-button--default {
        color: black !important;
        background-color: white !important;
        border: 1px solid #191D23 !important;
    }

    /* .el-button--default:focus, .el-button--default:hover {
            background: white;
            border-radius: 8px;
            border: 1px solid #191D23;
            border-radius: 8px;
            color: black;
        }*/

    .btn {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 10px;
        position: absolute;
        height: 40px;
        left: 297px;
        top: 0px;
        /* Primary/600 */
    }

    .el-button {
        display: flex !important;
        flex-direction: row !important;
        justify-content: center !important;
        align-items: center !important;
        padding: 10px !important;
        position: static !important;
        width: 285px !important;
        height: 50px !important;
        left: 199px !important;
        top: 0px !important;
        border-radius: 8px !important;
    }

    .el-button--success:focus,
    .el-button--success:hover {
        background: #1E228C !important;
        border-radius: 8px !important;
        /*border-color: none !important;*/
    }

    .right {
        padding: 16px;
        background: #FFFFFF;
        border-radius: 8px;
        margin-left: 20px;
    }

    .count {
        position: static;
        width: 330px;
        height: 40px;
        left: 0px;
        top: 0px;
        font-family: 'Inter';
        font-style: normal;
        font-weight: 600;
        font-size: 21px;
        line-height: 41px;
        /* or 195% */
        display: flex;
        align-items: center;
        letter-spacing: -0.04em;
        /* Neutral / Gray 900 */
        color: #0F172A;
    }

    .allresults {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        display: flex;
        align-items: center;
        letter-spacing: -0.04em;
        padding-top: 16px;
        margin-bottom: 10px;
    }

    .SearchCustomers {
        margin-top: 10px;
        /*border: 1px solid #333333;*/
        //box-sizing: border-box;
        border-radius: 8px;
        width: 790px;
        min-height: 48px !important;
        display: inline-block;
        /*display: flex;
        flex-direction: row;
        align-items: center;*/
    }

    /*.SearchCustomers {
        box-sizing: border-box;
        border-radius: 8px;*/
    /*border-color: #333333;*/
    /*border: 1px solid #333333;
        width: 795px;
        height: 48px !important;
    }*/

    .card {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding: 8px;
        position: static;
        width: 785px;
        height: 98px;
        left: 16px;
        top: 162px;
        background: #F6F6F6;
        border-radius: 8px;
    }

    .logo {
        position: absolute;
        width: 56px;
        height: 61.25px;
        background: url('https://logo.clearbit.com/spotify.com');
        position: absolute;
    }

    .text {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 22px;
        color: #48494D;
    }

    /* old CSS */
    .analysisbottomMargin50 {
        width: 100% !important;
    }

    .bottomHugging {
        position: sticky;
        bottom: 60px;
        height: 50px;
        background-color: rgba(30, 34, 140, 0.5);
        padding-top: 10px;
    }

    .compare {
        width: 300px;
    }

    .chartDiv {
        padding-left: 330px;
        min-width: auto;
        display: block
    }

        .chartDiv div,
        .chartDiv div div {
            display: block;
            min-width: auto;
        }

    #Quality + label {
        border-bottom-right-radius: 0 !important;
        border-top-right-radius: 0 !important;
    }

    #Pricing + label {
        border-bottom-left-radius: 0 !important;
        border-top-left-radius: 0 !important;
    }

    fieldset {
        text-align: center;
        margin-left: auto;
        width: 425px;
        margin-right: auto;
    }

        fieldset.customise {
            text-align: left;
            border: 3px solid #1e228c;
            padding: 0 0 0 10px;
            width: 300px;
            float: left;
            position: sticky;
            top: 0;
        }

            fieldset.customise legend {
                padding: 5px 5px 5px 5px;
                float: left;
            }

            fieldset.customise h3 {
                padding: 5px 5px 5px 5px;
                clear: both;
                color: #1e228c;
                font-weight: normal;
                border-top: 1px solid #1e228c;
            }

    .budget {
        display: block;
        margin: 5px 5px 5px 5px;
        position: relative;
        padding-left: 25px;
        border: solid 1px black;
    }

        .budget::before {
            content: "£";
            width: 10px;
            font-family: 'Roboto';
            color: #1e228c;
            display: inline-block;
            padding-left: 5px;
            font-size: 24px;
            text-align: left;
            position: absolute;
            left: 0px;
        }

        .budget input {
            border: none;
            font-size: 24px;
            padding: 0px 0px 0px 0px;
            display: block;
            width: 100%;
        }
    .ume {
        display: inline-flex;
        align-items: center;
        padding: 1px 10px;
        font-size: 14px;
        color: #404040;
        background-color: #DF722E;
        border: none;
        border-radius: 5px;
        text-align: center;
        cursor: pointer;
        margin-top: 20px;
    }

        .ume img {
            margin-left: 15px;
            max-width: 35%;
        }

        .ume span {
            color: white;
        }
</style>
<script>
    import AnalysisBreakdown from './AnalysisBreakdown.vue';
    import CollapsableBarChart from './CollapsableBarChart.vue';
    import PricingReportDetails from './PricingReportDetails.vue';
    import LoadingControl from './LoadingControl.vue';
    import $ from 'jquery';
    import helper from './HelperMethods.vue';
    import Advertisement from './Advertisement.vue';
    //import Key from './Key.vue';
    import ApplyNowModal from './ApplyNowModal.vue';
    import { supportsApply } from '../utils/integrations';
    import DownloadIllustration from './DownloadIllustration.vue';
    import { ElMessage } from 'element-plus';
    import LeftPanelReferences from './LeftPanelReferences.vue';
    import { openUmeRedirectTab } from '../utils/umeRedirect';
    import { useViewAs } from '../composables/useViewAs';
    export default {
        name: 'IncomeProtectionAnalysis',
        components: { AnalysisBreakdown, CollapsableBarChart, PricingReportDetails, LoadingControl, Advertisement, ApplyNowModal, DownloadIllustration, LeftPanelReferences },
        inject: ["SubscriptionService"],
        props: ["userSelection", "userDetails", "adverts"],
        setup() {
            const { isViewingAsOther } = useViewAs()
            return { isViewingAsOther }
        },
        data: function () {
            return {
                helper: helper,
                deferredPeriod: ['1 day', '1 Week', '2 Weeks', '1 Month', '2 Month', '3 Month', '6 Month', '12 Month', '24 Months'],
                IsApplyNow: false,
                IsLoading: false,
                LoadingDescription: null,
                advert: null,
                IsComparing: false,
                ShowAnalysisBreakdown: false,
                CompareSelection: [],
                Budget: null,
                //RemoveNotInBudget: false,
                Filter: 'All',
                Analysis: null,
                Error: null,
                SelectionAnalysisOption: JSON.stringify({ title: "Analysis", cat: null, feature: null }),
                IsRequestingReport: false,
                IsRequestingSummaryReport: false,
                Features: null,
                ExtendedFeatures: null,
                Providers: null,
                IsCancel: true,
                IsPricing: false,
                ExpandedProviders: { "keys": [] },
                AnalysisPremiumTypeFilter: ['Guaranteed', 'Guaranteed_AgeCosted', 'Reviewable', 'Reviewable_AgeCosted'],
                AnalysisBenefitTypeFilter: ['_1_Year_Benefit_Period', '_2_Year_Benefit_Period', '_5_Year_Benefit_Period', 'Full_Term'],
                AnalysisUMEFilter: ['NON_STANDARD', 'STANDARD', 'REFER', 'UNKNOWN', 'EVIDENCE_REQUIRED', 'POSTPONE', 'DECLINE'],
                AnalysisUMEExclusionFilter: ['EXCLUSION', ''],
                SelectedCustomFilterOptionKeys: [],
                ProductStarFilter: 'All',
                ratings: 3.7,
                activeNames: [''],
                FilterIPAnalysis: '',
                ValuesFilters: [],
                IsShowDownloadIllustration: false,
                customerType: null,
                isValidCustomer: false,
                IsDeductingCredit: false,
                analysisResponse: null,
                SelectedProviders: [],
            }
        },
        methods: {
            convertAddDeferredPeriod(value) {
                return value.replace('_', '').replace('_', ' ');
            },
            DownloadPDFReport: function (request) {
                var thisControl = this;
                var reportTitle = helper.GeneratePDFName(thisControl.UserSelection,
                    thisControl.userSelection.tool.toolName,
                    "Detail Report");
                thisControl.UserSelection.reportTitle = reportTitle;

                thisControl.UserSelection.includedProviders = thisControl.CompareSelection;
                thisControl.LoadingDescription = "Just a moment, we are preparing your report...";
                var pdfToDownload = null;
                var reportreference = null;
                var waiting = 1;
                var done = function () {
                    helper.downloadFile("application/pdf", reportTitle, pdfToDownload, '/customerreport/' + thisControl.UserSelection.customerReference + '/' + thisControl.Analysis.analysisReferecnce + "/" + reportreference);
                    thisControl.IsLoading = false;
                    thisControl.advert = null;
                    thisControl.IsRequestingReport = false; //close download report dialogue...
                };
                var adToShow = helper.GetAdvert(thisControl.adverts, "WhenDownloadingReport", thisControl.UserSelection);
                if (adToShow !== null) {
                    thisControl.advert = adToShow;
                    waiting++;
                    setTimeout(function () {
                        waiting--;
                        if (waiting == 0)
                            done();
                    }, adToShow.minimumDurationInSeconds * 1000);
                }
                thisControl.IsLoading = true;
                $.ajax({
                    type: 'POST',
                    url: "/report/longreportpdf",
                    contentType: 'application/json',
                    data: JSON.stringify(request),
                    success: function (pdf, _, request) {
                        pdfToDownload = pdf;
                        reportreference = request.getResponseHeader("ReportReference");
                        waiting--;
                        if (waiting == 0)
                            done();
                    },
                    error: function (xhr) {
                        if (xhr.status == 401) {
                            window.location = "./Api/signin";
                            return;
                        }
                        waiting--;
                        if (waiting == 0)
                            done();
                    }
                });
            },
            DownloadPDFShortReport: function (request) {
                var thisControl = this;
                thisControl.LoadingDescription = "Just a moment, we are preparing your report...";
                var reportTitle = helper.GeneratePDFName(thisControl.UserSelection,
                    thisControl.userSelection.tool.toolName,
                    "Short Report");
                thisControl.UserSelection.reportTitle = reportTitle;

                var reportreference = null;

                var pdfToDownload = null;
                var waiting = 1;
                var done = function () {
                    helper.downloadFile("application/pdf", reportTitle, pdfToDownload, '/customerreport/' + thisControl.UserSelection.customerReference + '/' + thisControl.Analysis.analysisReferecnce + "/" + reportreference);
                    thisControl.IsLoading = false;
                    thisControl.advert = null;
                    thisControl.IsRequestingReport = false; //close download report dialogue...
                };
                var adToShow = helper.GetAdvert(thisControl.adverts, "WhenDownloadingReport", thisControl.UserSelection);
                if (adToShow !== null) {
                    thisControl.advert = adToShow;
                    waiting++;
                    setTimeout(function () {
                        waiting--;
                        if (waiting == 0)
                            done();
                    }, adToShow.minimumDurationInSeconds * 1000);
                }
                thisControl.IsLoading = true;
                $.ajax({
                    type: 'POST',
                    url: "/report/shortreportpdf",
                    contentType: 'application/json',
                    data: JSON.stringify(request),
                    success: function (pdf, _, request) {
                        reportreference = request.getResponseHeader("ReportReference");
                        pdfToDownload = pdf;
                        waiting--;
                        if (waiting == 0)
                            done();
                    },
                    error: function (xhr) {
                        thisControl.IsLoading = false;
                        if (xhr.status == 401) {
                            window.location = "./Api/signin";
                            return;
                        }
                        waiting--;
                        if (waiting == 0)
                            done();
                        //alert("Problem Getting Report" + xhr.responseText);
                    }
                });
            },
            ReportDetails: function () {
                var thisControl = this;
                thisControl.UserSelection.includedProviders = thisControl.CompareSelection;
                thisControl.UserSelection.reportTitle = thisControl.ReportTitle;
                thisControl.UserSelection.extendedFeatures.filter(function (feature) { return feature.weight > 0 }).forEach(function (feature) {
                    if (thisControl.UserSelection.includeFeatureInDataTable !== undefined && thisControl.UserSelection.includeFeatureInDataTable.length > 0 && thisControl.UserSelection.includeFeatureInDataTable.includes(feature.featureReference))
                        feature.includeInDataTable = true;
                });

                thisControl.UserSelection.categoryWeightings.filter(function (category) { return category.weight > 0 }).forEach(function (category) {
                    if (thisControl.UserSelection.includeFeatureInDataTable !== undefined && thisControl.UserSelection.includeCategoryInDataTable.length > 0 && thisControl.UserSelection.includeCategoryInDataTable.includes(category.category)) {
                        thisControl.UserSelection.extendedFeatures.filter(function (feature) { return feature.weight > 0 && feature.featureCategory === category.category }).forEach(function (feature) {
                            feature.includeInDataTable = true;
                        });
                    }
                });

                return {
                    selection: thisControl.UserSelection,
                    analysis: thisControl.Analysis,
                    firstInsuredName: thisControl.UserSelection.primaryClient.forename + " " + thisControl.UserSelection.primaryClient.surname,
                    //firstInsuredName: thisControl.UserSelection.primaryClient.title + " " + thisControl.UserSelection.primaryClient.forename + " " + thisControl.UserSelection.primaryClient.surname,
                    secondInsuredName: null, //thisControl.UserSelection.secondaryClient === null ? null : thisControl.UserSelection.secondaryPersonName,
                    providersInDataTables: thisControl.HasDataTables ? thisControl.UserSelection.includedProviders : null,
                    reportTitle: "Test",
                    ShouldIncludeDefinitions: thisControl.ShouldIncludeDefinitions
                };
            },
            PerformComparison: function () {
                var comparisonUrl = "/api/Journey/Comparison";
                var thisControl = this;
                var request = thisControl.ReportDetails();
                thisControl.IsComparing = true;
                $.ajax({
                    type: 'POST',
                    url: comparisonUrl,
                    contentType: 'application/json',
                    data: JSON.stringify(request),
                    success: function () {
                        thisControl.IsComparing = false;
                        thisControl.ShowAnalysisBreakdown = true;
                    },
                    error: function (xhr) {
                        thisControl.IsComparing = false;
                        if (xhr.status == 401) {
                            window.location = "./Api/signin";
                            return;
                        }
                        //alert("Problem Getting Report" + xhr.responseText);
                    }
                });

            },
            ApplyNow: function (id) {
                var previousSelected = this.CompareSelection;
                var waiting = 2;
                this.IsLoading = true;
                this.LoadingDescription = "Just a moment, we will redirect you to insurer...";
                this.CompareSelection = [id];
                var applyNowUrl = null;
                var thisControl = this;
                var request = thisControl.ReportDetails();
                var done = function () {
                    window.open(applyNowUrl);
                    thisControl.CompareSelection = previousSelected;
                    thisControl.IsLoading = false;
                    thisControl.IsApplyNow = false;
                    thisControl.IsComparing = false;
                }
                thisControl.IsComparing = true;
                $.ajax({ //log mi
                    type: 'POST',
                    url: "/api/Journey/ApplyNow",
                    contentType: 'application/json',
                    data: JSON.stringify(request),
                    success: function () {
                        waiting--;
                        if (waiting == 0)
                            done();
                    },
                    error: function (xhr) {
                        if (xhr.status == 401) {
                            window.location = "./Api/signin";
                            return;
                        }
                        waiting--;
                        if (waiting == 0)
                            done();
                        thisControl.$message.error("Problem logging apply now: " + xhr.responseText);
                    }
                });
                var serviceType = thisControl.UserSelection.integration;
                if (serviceType === "UNDERWRITEME")
                {
                    id = thisControl.UserSelection.availableIPProducts.filter(function(p) {return p.quoteID == id})[0].productID;
                }
                $.ajax({ //get redirect uri
                    type: 'GET',
                    url: '/api/pricing/ApplyLink/' + serviceType + "/" + id + "/" + thisControl.UserSelection.externalApplicationId,
                    contentType: 'application/json',
                    success: function (data) {
                        applyNowUrl = data;
                        waiting--;
                        if (waiting == 0)
                            done();
                    },
                    error: function (xhr) {
                        if (xhr.status == 401) {
                            window.location = "./Api/signin";
                            return;
                        }
                        else if (xhr.status == 422) {
                            thisControl.$message.error(xhr.responseText)
                            thisControl.CompareSelection = previousSelected;
                            thisControl.IsLoading = false;
                        }
                        else
                        {
                            waiting--;
                            if (waiting == 0)
                                done();
                            thisControl.$message.error("Problem redirecting: " + xhr.responseText);
                        }
                    }
                });
            },
            DownloadIllustrations: function (id) {
                var previousSelected = this.CompareSelection;
                var waiting = 1;
                this.IsLoading = true;
                this.LoadingDescription = "Just a moment, we will getting your illustrations...";
                var thisControl = this;
                this.CompareSelection = [id];
                var request = thisControl.ReportDetails();
                var illlustrationmessages = [];
                var downloadNowUrl = null;
                var done = function () {
                    if (thisControl.UserSelection.externalApplicationId != null && thisControl.UserSelection.externalApplicationId.includes("UME")) {
                        helper.downloadFile("application/zip", helper.GetClientsName(thisControl.UserSelection) + ".pdf", downloadNowUrl, null);
                    }
                    else {
                        helper.downloadFile("application/zip", helper.GetClientsName(thisControl.UserSelection) + ".zip", downloadNowUrl, null);
                    }
                    thisControl.CompareSelection = previousSelected;
                    thisControl.IsLoading = false;
                    thisControl.IsShowDownloadIllustration = false;
                    thisControl.IsComparing = false;
                    for (var imindex = 0; imindex < illlustrationmessages.length; imindex++) {
                        var im = illlustrationmessages[imindex];
                        ElMessage({
                            message: im,
                            type: 'error',
                        })
                    }
                }
                thisControl.IsComparing = true;

                $.ajax({
                    type: 'POST',
                    url: '/api/illustration/Illustrations/' + id,
                    contentType: 'application/json',
                    data: JSON.stringify(request),
                    success: function (data, _, xhr) {
                        downloadNowUrl = data;
                        illlustrationmessages = JSON.parse(xhr.getResponseHeader("illustrationmessages"));
                        waiting--;
                        if (waiting == 0)
                            done();
                    },
                    error: function (xhr) {
                        if (xhr.status == 401) {
                            window.location = "./Api/signin";
                            return;
                        }
                        waiting--;
                        if (waiting == 0)
                            done();
                        thisControl.$message.error("Problem redirecting: " + xhr.responseText);
                    }
                });
            },
            AddLegacyProductToCompareSelection: function () {
                var thisControl = this;
                if (thisControl.FilteredProducts.length > 0) {
                    var legacyQuoteID = thisControl.FilteredProducts.filter(function (p) { return p.productID === thisControl.UserSelection.legacyPolicyProviderReference; })[0].quoteID;
                    if (legacyQuoteID !== null && legacyQuoteID !== undefined && !thisControl.CompareSelection.includes(legacyQuoteID))
                        thisControl.CompareSelection.push(legacyQuoteID);
                }
            },
            GoHome: function () { window.location.href = "/"; },

            ConvertFromIpipelineToUME: function () {
                var thisControl = this;

                if (thisControl.__umeClicking) return;
                thisControl.__umeClicking = true;

                const tabName = 'ume-redirect';
                const tab = openUmeRedirectTab(tabName);

                thisControl.UserSelection.underwritten = true;
                thisControl.UserSelection.pgpLinkedAnalysisReference = thisControl.Analysis.analysisReferecnce;
                thisControl.IsLoading = true;
                thisControl.LoadingDescription = "Just a moment, we will redirect you to insurer...";

                $.ajax({
                    type: 'POST',
                    url: "/Api/",
                    contentType: 'application/json',
                    data: JSON.stringify(thisControl.UserSelection),
                    success: (data) => {
                        const url = data?.url;
                        if (url) window.open(url, tabName);
                        if (data?.analysisReference)
                            thisControl.UserSelection.analysisReference = data.analysisReference;
                        thisControl.__umeClicking = false;
                        setTimeout(() => { window.location.href = "/"; }, 1500);
                    },
                    error: (xhr) => {
                        thisControl.IsLoading = false;
                        thisControl.__umeClicking = false;
                        tab?.close();
                        thisControl.$message?.error(xhr?.responseText || 'Error contacting the insurer.');
                        setTimeout(function () {
                            window.location.href = "/";
                        }, 2500);
                    }
                });
            },
            capitalizeWords(string) {
                const commonWordsToPreserve = ['the', 'and', 'of', 'in', 'on'];

                return string
                    .toLowerCase()
                    .replace(/_/g, ' ')
                    .replace(/\d+$/, '')
                    .split(' ')
                    .map(word => {
                        const cleanWord = word.replace(/[^a-zA-Z=]/g, '');

                        const isAcronym = /^[a-z=]{2,4}$/.test(cleanWord) && !commonWordsToPreserve.includes(cleanWord);

                        if (isAcronym) return word.toUpperCase();

                        return word.charAt(0).toUpperCase() + word.slice(1);
                    })
                    .join(' ')
                    .replace(/\s+/g, ' ')
                    .trim();
            }
        },
        watch: {
            FilterProductsInBudget: {
                deep: true,
                handler: function (newValue) {
                    var budget = this.UserSelection.clientBudget === "" ? null : this.UserSelection.clientBudget;
                    var thisControl = this;
                    if (newValue !== null) {
                        this.UserSelection.filteredQuotes = newValue.map(function (p) {
                            return {

                                errors: p.errors,
                                price: p.price,
                                productID: p.productID,
                                provider: p.provider,
                                displayName: p.displayName,
                                monthlyBenefit: p.monthlyBenefit,
                                reference: p.quoteID,
                                benefitType: p.benefitType,
                                premiumType: p.premiumType,
                                apiProductId: p.apiProductId,
                                decisionType: p.decisionType,
                                commission: p.commission
                            };
                        });
                        var premiumReasonMap =
                        {
                            'Guaranteed': 'Guaranteed premium',
                            'Guaranteed_AgeCosted': 'Guaranteed - age costed premium',
                            'Reviewable': 'Reviewable premium',
                            'Reviewable_AgeCosted': 'Reviewable - age costed'
                        }

                        var benefitReasonMap = {
                            '_1_Year_Benefit_Period': '1 Year Benefit Period',
                            '_2_Year_Benefit_Period': '2 Year Benefit Period',
                            '_5_Year_Benefit_Period': '5 Year Benefit Period',
                            'Full_Term': 'Full term benefit period'
                        }

                        var decisionMap =
                        {
                            'NON_STANDARD': 'Buy now non-standard',
                            'EVIDENCE_REQUIRED': 'Evidence Required',
                            'REFER': 'Referred',
                            'POSTPONE': "Can't offer cover now",
                            'DECLINE': "Can't offer cover",
                            'STANDARD': 'Buy now',
                        };

                        this.UserSelection.unavailableProducts =
                            helper.mergeArrays([
                                //Unavailable products from iPipeline.
                                this.UserSelection.highLevelUnavailableProducts,
                                //Products With Errors.
                                this.UserSelection.availableIPProducts.filter(function (p) { return p.errors != null && p.errors.length > 0; }).map(function (av) {
                                    return {
                                        displayName: av.displayName,
                                        productID: av.productID,
                                        reasons: av.errors,
                                        provider: av.provider,
                                        apiProductId: av.apiProductId,
                                    };
                                }),
                                //Products Filtered Out
                                this.AllProducts
                                    .map(function (p) {
                                        return {
                                            reasons: helper.mergeArrays([
                                                [
                                                    thisControl.AnalysisPremiumTypeFilter.includes(p.premiumType) ? null : premiumReasonMap[p.premiumType],
                                                    thisControl.AnalysisBenefitTypeFilter.includes(p.benefitType) ? null : benefitReasonMap[p.benefitType],
                                                    thisControl.RemoveNotInBudget && budget !== null && budget < p.price ? "Not in budget" : null,
                                                    p.decisionType && !thisControl.AnalysisUMEFilter.includes(p.decisionType) ? decisionMap[p.decisionType] : null
                                                ].filter(function (a) { return a !== null; }),
                                                helper.mergeArrays(
                                                    thisControl.Analysis.providerFilters.map(function (f) {
                                                        return f.providerFilterOptions
                                                            .map(function (fo) {
                                                                var providerFilters = p.providerFilters ?? thisControl.ProviderLookup[p.productID].providerFilters;
                                                                return thisControl.SelectedCustomFilterOptionKeys.indexOf(fo.reference) == -1
                                                                    && providerFilters !== null
                                                                    && providerFilters !== undefined
                                                                    && providerFilters[f.providerFilterReference]
                                                                    && providerFilters[f.providerFilterReference].includes(fo.reference)
                                                                    ? fo.option
                                                                    : null;
                                                            })
                                                            .filter(function (fo) { return fo != null; });
                                                    })
                                                )
                                            ]),
                                            price: p.price,
                                            productID: p.productID,
                                            provider: p.provider,
                                            displayName: p.displayName,
                                            reference: p.quoteID,
                                            isFiltered: true,
                                            apiProductId: p.apiProductId,
                                        };
                                    })
                                    .filter(function (a) { return a.reasons.length > 0; })
                            ]);

                        if (this.UserDetails.isAdminUser) {
                            console.log(this.UserSelection.filteredQuotes.map(function (a) { return a.productID + ": " + a.displayName }).join("\n"));
                        }
                    }
                }
            },
            DisplayableProductFilters: {
                deep: true,
                handler: function (newvalue) {
                    this.UserSelection.productFilters = newvalue;
                }
            },
            MainChartData: {
                deep: true,
                handler: function (val) {
                    if (val == null)
                        return;
                    var newSelection = this.CompareSelection.filter(function (s) {
                        return val.items.some(function (g) { return g.values.some(function (v) { return v.Reference === s; }); })
                    });
                    if (newSelection.length < this.CompareSelection.length)
                        this.CompareSelection = newSelection;


                    newSelection = this.UserSelection.includedProviders.filter(function (s) {
                        return val.items.some(function (g) { return g.values.some(function (v) { return v.Reference === s; }); })
                    });
                    if (newSelection.length < this.UserSelection.includedProviders.length)
                        this.UserSelection.includedProviders = newSelection;

                    if (this.UserSelection.legacyPolicyProviderReference) {
                        this.AddLegacyProductToCompareSelection();
                    }

                    this.UserSelection.productsInFocus = this.CompareSelection;
                }
            },
            SelectFeatureInAnalysis: function (val, oldVal) {
                var thisControl = this;
                if (val === oldVal)
                    return;
                if (thisControl.Analysis === null)
                    return;
                if (val === null) {
                    thisControl.SelectedSubFeatureInAnalysis = null;
                    return
                }
                var featureAnalysis = thisControl.Analysis.featureAnalysis[val];
                if (featureAnalysis !== null && featureAnalysis.subFeatureAnalysis !== null && featureAnalysis.subFeatureAnalysis.length > 0)
                    thisControl.SelectedSubFeatureInAnalysis = featureAnalysis.subFeatureAnalysis[0].subFeatureReference; //select the first subfeature...

            },
            ProductStarFilter: function () {
                if (this.MainChartData !== null) {
                    if (this.ProductStarFilter === 'Best quality in budget') {
                        this.MainChartData = null;

                        //this.MainChartData.items.filter(function (itm) { if (itm.values) return values }).filter(function (val) { return val[0] }).values[0].DisplayValues[3].BestInBudget
                        //this.MainChartData.items[0].values[0].DisplayValues[3].BestInBudget
                    }
                    //else if (this.ProductStarFilter === 'In budget') {

                    //}
                    //else if (this.ProductStarFilter === 'Lowest premium') {

                    //}
                    //else { }
                }
            },
            "UserSelection.clientBudget": function (val) {
                if (isFinite(val))
                    if (val * 1 > 0) {
                        //there is a budget so all no action required
                        return;
                    }
                //there is no budget so check filters
                if (this.Filter === 'In budget' || this.Filter === 'Best quality in budget')
                    this.Filter = 'All';
            },
            "IsRequestingReport": function (val) {
                if (this.UserSelection.legacyPolicyProviderReference !== null && this.UserSelection.legacyPolicyProviderReference !== '' && val === true && this.CompareSelection.length > 2) {
                    this.CompareSelection = [];
                    this.AddLegacyProductToCompareSelection();
                }
            },
            AllProducts(newProducts) {
                if (newProducts.length > 0) {
                    this.SelectedProviders = this.AllUniqueResultProviders;
                }
            },
            SelectedProviders(newVal) {
                this.UserSelection.uncheckedProvidersList = this.AllUniqueResultProviders.filter(
                    (provider) => !newVal.includes(provider)
                );
            }
        },
        computed: {
            CanApply: function () { return supportsApply(this.UserSelection.integration); },
            UserSelection: function () { return this.analysisResponse?.userSelection || this.userSelection; },
            UserDetails: function () { return this.userDetails; },
            RemoveNotInBudget: {
                get: function () {
                    return this.Filter === 'In budget' || this.Filter === "Best quality in budget";
                },
                set: function (value) {
                    if (value)
                        this.Filter = 'In budget';
                    else
                        this.Filter = 'All';
                }
            },
            DisplayableProductFilters: function () {
                var thisControl = this;
                var premiumMap = [
                    { key: 'Guaranteed', value: 'Plans with guaranteed premiums' },
                    { key: 'Guaranteed_AgeCosted', value: 'Plans with guaranteed - age costed premiums' },
                    { key: 'Reviewable', value: 'Plans with reviewable premiums' },
                    { key: 'Reviewable_AgeCosted', value: 'Plans with reviewable - age costed premiums' }
                ];
                var decisionMap = [
                    { key: 'EVIDENCE_REQUIRED', value: 'Evidence Required' },
                    { key: 'REFER', value: 'Referred' },
                    { key: 'POSTPONE', value: 'Can not offer cover now' },
                    { key: 'DECLINE', value: 'Can not offer' }
                ];
                var benefitmap = [
                    { key: '_1_Year_Benefit_Period', value: 'Plans with 1 Year Benefit Period' },
                    { key: '_2_Year_Benefit_Period', value: 'Plans with 2 Year Benefit Period' },
                    { key: '_5_Year_Benefit_Period', value: 'Plans with 5 Year Benefit Period' },
                    { key: 'Full_Term', value: 'Plans with full term benefit period' }
                ];
                var result = premiumMap
                    .filter(function (p) { return thisControl.AnalysisPremiumTypeFilter.indexOf(p.key) === -1; })
                    .map(function (p) { return p.value; });

                result = helper.mergeArrays(
                    [
                        result,
                        // 1. Filter benefitmap based on AnalysisBenefitTypeFilter
                        benefitmap
                            .filter(function (p) { return thisControl.AnalysisBenefitTypeFilter.indexOf(p.key) === -1; })
                            .map(function (p) { return p.value; }),
                        // 2. Add unselected custom filter options from providerFilters (safe null check)
                        helper.mergeArrays(
                            (this.Analysis?.providerFilters ?? [])
                                .map(function (o) {
                                    return o.providerFilterOptions
                                        .filter(function (f) {
                                            return thisControl.SelectedCustomFilterOptionKeys.indexOf(f.reference) == -1;
                                        })
                                        .map(function (f) { return f.option; });
                                })
                        ),
                        // 3. Filter decisionMap based on AnalysisUMEFilter
                        decisionMap
                            .filter(function (p) { return thisControl.AnalysisUMEFilter.indexOf(p.key) === -1; })
                            .map(function (p) { return p.value; })
                    ]
                );

                if (thisControl.RemoveNotInBudget && this.UserSelection.clientBudget !== null) {
                    result.push("Plans not in budget");
                }
                return result;
            },
            SelectedProducts: function () {
                var thisControl = this;
                var selection = Array.isArray(thisControl.CompareSelection) ? thisControl.CompareSelection : [];

                if (selection.length === 0)
                    return [];

                var filteredProducts = Array.isArray(thisControl.FilteredProducts) ? thisControl.FilteredProducts : [];
                var allProducts = Array.isArray(thisControl.UserSelection.availableIPProducts) ? thisControl.UserSelection.availableIPProducts : [];

                var resolveById = function (id) {
                    return filteredProducts.find(function (p) { return p.quoteID === id; })
                        || allProducts.find(function (p) { return p.quoteID === id; });
                };

                return selection
                    .map(resolveById)
                    .filter(function (product) { return product !== undefined && product !== null; });

            },
            OptionsInAnalysis: function () {
                var thisControl = this;
                var returnedCategories = this.Analysis.categoryAnalysis;
                var result = Object.keys(returnedCategories)
                    .sort(function (a, b) {
                        return thisControl.UserSelection.categoryWeightings.indexOf(a) - thisControl.UserSelection.categoryWeightings.indexOf(b)
                    })
                    .map(function (category) {
                        var cat = {
                            optionValue: JSON.stringify({ title: category, cat: category, feature: null }),
                            optionText: " - " + category
                        }
                        var result = Object.keys(returnedCategories[category].featureAnalysis)
                            .map(function (featureReference) {
                                var featureName = thisControl.UserSelection.extendedFeatures.filter(function (ef) { return ef.featureReference == featureReference })[0].featureName;
                                return {
                                    optionValue: JSON.stringify({ title: featureName, cat: category, feature: featureReference }),
                                    optionText: "\u00a0\u00a0\u00a0- " + featureName
                                };
                            })
                            .sort(function (a, b) {
                                if (a.optionText < b.optionText)
                                    return -1;
                                if (a.optionText > b.optionText)
                                    return 1;
                                return 0;
                            });
                        result.unshift(cat)
                        return result;
                    });
                result = helper.mergeArrays(result);
                result.unshift({
                    optionValue: JSON.stringify({ title: "Analysis", cat: null, feature: null }),
                    optionText: "Overall"
                });
                return result;
            },
            MainChartAdditionalHeadings: function () {
                if (this.UserSelection.ipBenefitBasis === "Maximum")
                    return [['Quality', 'Score'], ['Price'], ["Monthly", "Benefit"], ['Product', 'Key']];
                else
                    return [['Quality', 'Score'], ['Price'], ['Product', 'Key']];
            },
            AllProducts: function () {
                var thisControl = this;
                return thisControl.UserSelection.availableIPProducts.filter(function (p) { return p.errors === null || p.errors.length === 0; }).filter(function (ap) {
                    return thisControl.UserSelection.selectedQuotes.some(function (sq) { return sq === ap.quoteID; });
                });
            },
            FilteredProducts: function () {
                if (this.ProviderLookup === null)
                    return null;
                var thisControl = this;
                var products = this.AllProducts;

                if (this.SelectedProviders.length === 0) {
                    return [];
                }

                if (this.SelectedProviders.length > 0 && this.SelectedProviders.length != this.AllUniqueResultProviders.length) {
                    products = products.filter(function (p) {
                        const providerCoreName = helper.GetProviderLogoByName(p.displayName);
                        return thisControl.SelectedProviders.includes(thisControl.capitalizeWords(providerCoreName));
                    });
                }

                if (this.AnalysisPremiumTypeFilter !== null)
                    products = products.filter(function (p) { return thisControl.AnalysisPremiumTypeFilter.includes(p.premiumType); });

                if (this.AnalysisBenefitTypeFilter !== null)
                    products = products.filter(function (p) { return thisControl.AnalysisBenefitTypeFilter.includes(p.benefitType); });

                if (this.UserSelection.underwritten && this.AnalysisUMEFilter !== null)
                    products = products.filter(function (p) {
                        return thisControl.AnalysisUMEFilter.includes(p.decisionType);
                    });
                if (this.UserSelection.underwritten && this.AnalysisUMEExclusionFilter != null)
                    products = products.filter(function (p) {
                        return thisControl.AnalysisUMEExclusionFilter.includes(p.indicativeLoadingContributors != null && p.indicativeLoadingContributors.some(d => !!d.indicativeExclusionContributions || !!d.exclusionContributions) ? "EXCLUSION" : '');
                    });

                products = helper.ApplyProductFilters(
                    products.filter(function (p) { return p.productID !== thisControl.UserSelection.legacyPolicyProviderReference }),
                    function (p) { return p.providerFilters ? p : thisControl.ProviderLookup[p.apiProductId]; },
                    thisControl.Analysis.providerFilters,
                    thisControl.SelectedCustomFilterOptionKeys
                );

                //Added the legacy products from all prodcuts
                if (thisControl.userSelection.legacyPolicyProviderReference !== null && thisControl.userSelection.legacyPolicyProviderReference !== '')
                    products.push(this.AllProducts.filter(function (p) { return p.productID === thisControl.userSelection.legacyPolicyProviderReference; })[0]);

                return products;
            },
            FilterProductsInBudget: function () {
                if (this.FilteredProducts === null)
                    return null;
                var thisControl = this;
                var budget = this.UserSelection.clientBudget === "" ? null : this.UserSelection.clientBudget;
                var prods = this.FilteredProducts;
                const isLegacy = (p) => p.productID === thisControl.userSelection.legacyPolicyProviderReference;
                switch (this.Filter) {
                    case "All":
                        return prods;
                    //break;
                    case "In budget":
                        return prods.filter(function (p) { return !thisControl.RemoveNotInBudget || budget === null || isLegacy(p) || (budget >= p.price && p.price > 0); })
                    //break;
                    case "Best quality in budget":
                        var scoresInBudget = this.FilteredProducts
                            .filter(function (p) {
                                return budget !== null && budget >= (1 * p.price) && p.price > 0;
                            })
                            .map(function (p) {
                                return parseFloat(thisControl.Analysis.providerScores[p.apiProductId]);
                            });
                        var bestQualityInBudget = Math.max(...scoresInBudget);
                        return prods.filter(function (p) { return budget === null || isLegacy(p) || (budget >= p.price && p.price > 0 && bestQualityInBudget === thisControl.Analysis.providerScores[p.apiProductId]); });
                    //break;
                    case "Lowest premium":
                        var prices = prods.map(function (p) { return p.price; });
                        var minPrice = Math.min(...prices.filter(x=> x > 0));
                        return prods.filter(function (p) { return isLegacy(p) || minPrice === p.price });
                    //break;
                }
                return this.FilteredProducts.filter(function (p) { return !thisControl.RemoveNotInBudget || budget === null || isLegacy(p) || (budget >= p.price && p.price > 0); })
            },
            ProviderLookup: function () {
                if (this.Analysis === null)
                    return null;
                if (this.Analysis.providers === null || this.Analysis.providers === undefined)
                    return null;
                return this.Analysis.providers.reduce(
                    function (rv, x) {
                        var v = x.providerReference;
                        rv[v] = x;
                        return rv;
                    }, {});
            },
            MainChartData: function () {
                var base = this.Analysis;
                if (base === null || base === undefined)
                    return null;
                var thisControl = this;
                var products = thisControl.FilteredProducts;
                if (products == null)
                {
                    return {
                        showLegend: false,
                        max: 100.0,
                        items: []
                    };
                }

                var budget = thisControl.UserSelection.clientBudget === "" ? null : thisControl.UserSelection.clientBudget * 1;
                var prices = products.map(function (p) { return p.price; });
                var scores = this.FilteredProducts.filter(function (p) { return p.price > 0 }).map(function (p) { return parseFloat(base.providerScores[p.apiProductId]); });
                var scoresInBudget = this.FilteredProducts.filter(function (p) { return budget !== null && budget >= (1 * p.price) && p.price > 0; }).map(function (p) { return parseFloat(base.providerScores[p.apiProductId]); });
                var minPrice = Math.min(...prices.filter(x=> x > 0));
                var bestQuality = Math.max(...scores);
                var bestQualityInBudget = Math.max(...scoresInBudget);
                var baseArray = thisControl.FilterProductsInBudget.map(function (a) { return a; });

                if (thisControl.IsPricing === 'maxBenefits' && thisControl.UserSelection.ipBenefitBasis === "Maximum") {
                    baseArray = baseArray.sort(function (a, b) {
                        return (b.monthlyBenefit || 0) - (a.monthlyBenefit || 0);
                    });
                }
                else if (thisControl.IsPricing === true || thisControl.IsPricing === 'true') {

                    baseArray = baseArray.sort(function (a, b) { return a.price - b.price; });

                }
                else {
                    baseArray = baseArray.sort(function (a, b) { return !a.price || !b.price ? - 1 :  base.providerScores[b.apiProductId] - base.providerScores[a.apiProductId]; });
                }

                var data = baseArray.map(function (p) {
                    return {
                        Label: p.displayName,
                        Logo: '/logos/' + (p.productID === thisControl.userSelection.legacyPolicyProviderReference ? "legacy" : p.provider) + '.png',
                        Tooltip: ((p.warnings !== null ? "Warnings:\n" + p.warnings.join("\n") : "\n") + (p.errors != null && p.errors.length > 0 ? "Errors:\n" + p.errors.join("\n") : "\n")).trim(),
                        Value: parseFloat(base.providerScores[p.apiProductId]).toFixed(2) * 1,
                        Color: thisControl.ProviderLookup[p.apiProductId].providerColor,
                        Reference: p.quoteID,
                        Group: p.provider,
                        DisplayValue: '',
                        HasTooltip: p.warnings.length === 0 || p.warnings.length > 0,
                        DisplayValues:
                            (thisControl.UserSelection.ipBenefitBasis === "Maximum") ?
                                [
                                    parseFloat(base.providerScores[p.apiProductId]).toFixed(1),
                                    "\u00A3" + (p.price === 0 ? " -" : (1 * p.price).toFixed(2)),
                                    "\u00A3" + (1 * p.monthlyBenefit).toFixed(2),
                                    {
                                        BestQuality: bestQuality === parseFloat(base.providerScores[p.apiProductId]),
                                        BestInBudget: budget !== null && (budget >= (1 * p.price) && p.price > 0) && bestQualityInBudget === parseFloat(base.providerScores[p.apiProductId]),
                                        InBudget: budget !== null && (budget >= (1 * p.price) && p.price > 0),
                                        LowestPremium: minPrice === 1 * p.price,
                                        Standard: p.decisionType === "STANDARD" && p.price > 0 ? true : false,
                                        NonStandard: p.decisionType === "NON_STANDARD"? true : false,
                                        Refer: p.decisionType === "REFER"? true : false,
                                        Decline: p.decisionType === "DECLINE" ? true : false,
                                        Postpone: p.decisionType === "POSTPONE" ? true : false,
                                        EvidenceRequired: p.decisionType === "EVIDENCE_REQUIRED" ? true : false,
                                        Exclusion: p.indicativeLoadingContributors != null && p.indicativeLoadingContributors.some(d => !!d.indicativeExclusionContributions || !!d.exclusionContributions)
                                    },
                                    "\u00A3" + (p.price === 0 ? " -" : (1 * p.priceTo).toFixed(2))
                                ]
                                :
                                [
                                    parseFloat(base.providerScores[p.apiProductId]).toFixed(1),
                                    "\u00A3" + (p.price === 0 ? " -" : (1 * p.price).toFixed(2)),
                                    {
                                        BestQuality: p.productID === thisControl.userSelection.legacyPolicyProviderReference ? false : bestQuality === parseFloat(base.providerScores[p.apiProductId]),
                                        BestInBudget: p.productID === thisControl.userSelection.legacyPolicyProviderReference ? false : budget !== null && (budget >= (1 * p.price) && p.price > 0) && bestQualityInBudget === parseFloat(base.providerScores[p.apiProductId]),
                                        InBudget: p.productID === thisControl.userSelection.legacyPolicyProviderReference ? false : budget !== null && (budget >= (1 * p.price) && p.price > 0),
                                        LowestPremium: p.productID === thisControl.userSelection.legacyPolicyProviderReference ? false : minPrice === 1 * p.price,
                                        Standard: p.decisionType === "STANDARD" && p.price > 0 ? true : false,
                                        NonStandard: p.decisionType === "NON_STANDARD"? true : false,
                                        Refer: p.decisionType === "REFER"? true : false,
                                        Decline: p.decisionType === "DECLINE" ? true : false,
                                        Postpone: p.decisionType === "POSTPONE" ? true : false,
                                        EvidenceRequired: p.decisionType === "EVIDENCE_REQUIRED" ? true : false,
                                        Exclusion: p.indicativeLoadingContributors != null && p.indicativeLoadingContributors.some(d => !!d.indicativeExclusionContributions || !!d.exclusionContributions)
                                    },
                                    "\u00A3" + (p.price === 0 ? " -" : (1 * p.priceTo).toFixed(2))
                                ],
                        IndicativeLoadingContributors: p.indicativeLoadingContributors,
                        //Customer: p.customer,
                        KeyFactsLink: p.keyFactsLink,
                        TermsAndConditionsLink: p.termsAndConditionsLink,
                        outlineBoxColor: null,
                        datatableBoxColor: null,
                        tableData: thisControl.UserSelection.categoryWeightings
                            .filter(function (cat) {
                                return cat.weight > 0
                            })
                            .map(function (cat) {
                                return {
                                    category: cat.category,
                                    score: thisControl.Analysis.categoryAnalysis[cat.category].providerScores[p.apiProductId].toFixed(0) * 1
                                };
                            }),
                        IsLegacy: p.productID === thisControl.userSelection.legacyPolicyProviderReference
                    }
                });

                return {
                    showLegend: false,
                    max: 100.0,
                    items: helper.groupByArray(data, "Reference")
                };
            },
            SelectedMainChartData: function () {
                var result = this.MainChartData;
                var thisControl = this;
                if (thisControl.UserSelection.legacyPolicyProviderReference !== null && thisControl.UserSelection.legacyPolicyProviderReference !== '')
                    thisControl.AddLegacyProductToCompareSelection();

                let items = result.items.filter(function (a) {
                    return thisControl.CompareSelection.indexOf(a.values[0].Reference) >= 0;
                });

                items.sort(function (a) {
                    return a.values[0]?.IsLegacy ? -1 : 1;
                });

                if (thisControl.IsPricing === 'maxBenefits' && thisControl.UserSelection.ipBenefitBasis === "Maximum") {
                    items.sort(function (a, b) {
                        const maxA = parseFloat(
                            (a.values[0]?.DisplayValues?.[2] || '£0').replace(/£|,/g, '')
                        ) || 0;
                        const maxB = parseFloat(
                            (b.values[0]?.DisplayValues?.[2] || '£0').replace(/£|,/g, '')
                        ) || 0;
                        return maxB - maxA; 
                    });
                }

                return {
                    showLegend: result.showLegend,
                    max: result.max,
                    items: items
                };
            },
            UnselectedMainChartData: function () {
                var result = this.MainChartData;
                var thisControl = this;

                return {
                    showLegend: result.showLegend,
                    max: result.max,
                    items: result.items.filter(function (a) { return thisControl.CompareSelection.indexOf(a.values[0].Reference) < 0 })
                };
            },
            ProductData: function () {
                var base = this.Analysis;
                if (base === null)
                    return null;
                var thisControl = this;
                var products = thisControl.FilteredProducts;
                var budget = thisControl.UserSelection.clientBudget === "" ? null : thisControl.UserSelection.clientBudget * 1;
                var prices = products.map(function (p) { return p.price; });
                var scores = this.FilteredProducts.map(function (p) { return parseFloat(base.providerScores[p.apiProductId]); });
                var scoresInBudget = this.FilteredProducts
                    .filter(function (p) {
                        return budget !== null && budget >= (1 * p.price);
                    }).map(function (p) {
                        return parseFloat(base.providerScores[p.apiProductId]);
                    });
                var minPrice = Math.min(...prices.filter(x=> x > 0));
                var bestQuality = Math.max(...scores);
                var bestQualityInBudget = Math.max(...scoresInBudget);
                if (this.IsPricing) {

                    return {
                        showLegend: false,
                        max: Math.max(...thisControl.AllProducts.map(function (p) { return p.price; })),
                        items: helper.groupByArray(thisControl.FilterProductsInBudget
                            .map(
                                function (p) {
                                    return {
                                        Logo: '/logos/' + (p.productID === thisControl.userSelection.legacyPolicyProviderReference ? "legacy" : p.provider) + '.png',
                                        Color: thisControl.ProviderLookup[p.apiProductId].providerColor,
                                        Value: p.price,
                                        Label: p.displayName,
                                        Tooltip: ((p.warnings.length > 0 ? "Warnings:\n" + p.warnings.join("\n") : "\n") + (p.errors != null && p.errors > 0 ? "Errors:\n" + p.errors.join("\n") : "\n")).trim(),
                                        Reference: p.quoteID,
                                        Group: p.provider,
                                        DisplayValue: "",
                                        HasTooltip: p.warnings.length > 0,
                                        DisplayValues:
                                            (thisControl.UserSelection.ipBenefitBasis === "Maximum") ?
                                                [
                                                    parseFloat(base.providerScores[p.apiProductId]).toFixed(0),
                                                    "\u00A3" + (1 * p.price).toFixed(2),
                                                    "\u00A3" + (1 * p.monthlyBenefit).toFixed(2),
                                                    {
                                                        BestQuality: bestQuality === parseFloat(base.providerScores[p.apiProductId]),
                                                        BestInBudget: budget !== null && budget >= (1 * p.price) && bestQualityInBudget === parseFloat(base.providerScores[p.apiProductId]),
                                                        InBudget: budget !== null && budget >= (1 * p.price),
                                                        LowestPremium: minPrice === 1 * p.price
                                                    }
                                                ]
                                                :
                                                [
                                                    parseFloat(base.providerScores[p.apiProductId]).toFixed(0),
                                                    "\u00A3" + (1 * p.price).toFixed(2),
                                                    {
                                                        BestQuality: bestQuality === parseFloat(base.providerScores[p.apiProductId]),
                                                        BestInBudget: budget !== null && budget >= (1 * p.price) && bestQualityInBudget === parseFloat(base.providerScores[p.apiProductId]),
                                                        InBudget: budget !== null && budget >= (1 * p.price),
                                                        LowestPremium: minPrice === 1 * p.price
                                                    }
                                                ],
                                        outlineBoxColor: null,
                                        datatableBoxColor: base.providerScores[p.apiProductId] > 50 ? 'yellow' : null
                                    }
                                })
                            .sort(function (a, b) {
                                if (thisControl.IsPricing === 'maxBenefits' && thisControl.UserSelection.ipBenefitBasis === "Maximum") {
                                    const benefitA = a.DisplayValues?.[2] ? parseFloat(a.DisplayValues[2].replace(/£|,/g, '')) : 0;
                                    const benefitB = b.DisplayValues?.[2] ? parseFloat(b.DisplayValues[2].replace(/£|,/g, '')) : 0;
                                    return benefitB - benefitA;
                                } else {
                                    return a.Value - b.Value;
                                }
                            }), ("Reference"))
                    }
                }
                else {

                    var data = thisControl.FilterProductsInBudget.map(function (p) {
                        return {
                            Logo: '/logos/' + (p.productID === thisControl.userSelection.legacyPolicyProviderReference ? "legacy" : p.provider) + '.png',
                            Label: p.displayName,
                            Tooltip: ((p.warnings.length > 0 ? "Warnings:\n" + p.warnings.join("\n") : "\n") + (p.errors != null && p.errors.length > 0 ? "Errors:\n" + p.errors.join("\n") : "\n")).trim(),
                            Value: parseFloat(base.providerScores[p.apiProductId]).toFixed(2) * 1,
                            Color: thisControl.ProviderLookup[p.apiProductId].providerColor,
                            Reference: p.quoteID,
                            Group: p.provider,
                            DisplayValue: '',
                            HasTooltip: p.warnings.length > 0,
                            DisplayValues:
                                (thisControl.UserSelection.ipBenefitBasis === "Maximum") ?
                                    [
                                        parseFloat(base.providerScores[p.apiProductId]).toFixed(0),
                                        "\u00A3" + (1 * p.price).toFixed(2),
                                        "\u00A3" + (1 * p.monthlyBenefit).toFixed(2),
                                        {
                                            BestQuality: bestQuality === parseFloat(base.providerScores[p.apiProductId]),
                                            BestInBudget: budget !== null && budget >= (1 * p.price) && bestQualityInBudget === parseFloat(base.providerScores[p.apiProductId]),
                                            InBudget: budget !== null && budget >= (1 * p.price),
                                            LowestPremium: minPrice === 1 * p.price
                                        }
                                    ]
                                    :
                                    [
                                        parseFloat(base.providerScores[p.apiProductId]).toFixed(0),
                                        "\u00A3" + (1 * p.price).toFixed(2),
                                        {
                                            BestQuality: bestQuality === parseFloat(base.providerScores[p.apiProductId]),
                                            BestInBudget: budget !== null && budget >= (1 * p.price) && bestQualityInBudget === parseFloat(base.providerScores[p.apiProductId]),
                                            InBudget: budget !== null && budget >= (1 * p.price),
                                            LowestPremium: minPrice === 1 * p.price
                                        }
                                    ],
                            outlineBoxColor: null,
                            datatableBoxColor: null
                        }
                    });
                }
                data = data.sort(function (a, b) { return b.Value - a.Value; });

                return data;
            },
            OverallChartData: function () {

                var base = this.Analysis;
                if (base === null)
                    return null;
                var thisControl = this;
                var products = thisControl.FilteredProducts;
                var budget = thisControl.UserSelection.clientBudget === "" ? null : thisControl.UserSelection.clientBudget * 1;
                var prices = products.map(function (p) { return p.price; });
                var scores = this.FilteredProducts.filter(function (p) { return p.price > 0 }).map(function (p) { return parseFloat(base.providerScores[p.apiProductId]); });
                var scoresInBudget = this.FilteredProducts
                    .filter(function (p) {
                        return budget !== null && budget >= (1 * p.price);
                    })
                    .map(function (p) {
                        return parseFloat(base.providerScores[p.apiProductId]);
                    });
                var minPrice = Math.min(...prices.filter(x=> x > 0));
                var bestQuality = Math.max(...scores);
                var bestQualityInBudget = Math.max(...scoresInBudget);

                var dataFilteredInBudget = thisControl.FilterProductsInBudget;


                if (thisControl.IsPricing === 'maxBenefits' && thisControl.UserSelection.ipBenefitBasis === "Maximum") {
                    dataFilteredInBudget = dataFilteredInBudget.sort(function (a, b) {
                        const benefitA = a.monthlyBenefit ? parseFloat(a.monthlyBenefit) : 0;
                        const benefitB = b.monthlyBenefit ? parseFloat(b.monthlyBenefit) : 0;
                        return benefitB - benefitA;
                    });
                }
                else if (thisControl.IsPricing === true || thisControl.IsPricing === 'true') {
                    dataFilteredInBudget = dataFilteredInBudget.sort(function (a, b) { return a.price - b.price; });
                }
                else {
                    dataFilteredInBudget = dataFilteredInBudget.sort(function (a, b) { return !a.price || !b.price ? - 1 :  base.providerScores[b.apiProductId] - base.providerScores[a.apiProductId]; });
                }

                var data = dataFilteredInBudget.map(function (p) {
                    return {
                        Label: p.displayName,
                        Tooltip: ((p.warnings.length > 0 ? "Warnings:\n" + p.warnings.join("\n") : "\n") + (p.errors != null && p.errors.length > 0 ? "Errors:\n" + p.errors.join("\n") : "\n")).trim(),
                        Value: parseFloat(base.providerScores[p.apiProductId]).toFixed(2) * 1,
                        Color: thisControl.ProviderLookup[p.apiProductId].providerColor,
                        // todo: We will need to change it when we add a new pricing integration, saving the integration value into the Analysis
                        Reference: p.quoteID,
                        Logo: '/logos/' + (p.productID === thisControl.userSelection.legacyPolicyProviderReference ? "legacy" : p.provider) + '.png',
                        Group: p.provider,
                        DisplayValue: '',
                        HasTooltip: p.warnings.length > 0,
                        tableData: [],
                        DisplayValues:
                            (thisControl.UserSelection.ipBenefitBasis === "Maximum") ?
                                [
                                    parseFloat(base.providerScores[p.apiProductId]).toFixed(0),
                                    "\u00A3" + (1 * p.price).toFixed(2),
                                    "\u00A3" + (1 * p.monthlyBenefit).toFixed(2),
                                    {
                                        BestQuality: bestQuality === parseFloat(base.providerScores[p.apiProductId]),
                                        BestInBudget: budget !== null && budget >= (1 * p.price) && bestQualityInBudget === parseFloat(base.providerScores[p.apiProductId]),
                                        InBudget: budget !== null && budget >= (1 * p.price),
                                        LowestPremium: minPrice === 1 * p.price,
                                        Standard: p.decisionType === "STANDARD" && p.price > 0 ? true : false,
                                        NonStandard: p.decisionType === "NON_STANDARD"? true : false,
                                        Refer: p.decisionType === "REFER"? true : false,
                                        Decline: p.decisionType === "DECLINE" ? true : false,
                                        Postpone: p.decisionType === "POSTPONE" ? true : false,
                                        EvidenceRequired: p.decisionType === "EVIDENCE_REQUIRED" ? true : false,
                                        Exclusion: p.indicativeLoadingContributors != null && p.indicativeLoadingContributors.some(d => !!d.indicativeExclusionContributions || !!d.exclusionContributions)
                                    }
                                ]
                                :
                                [
                                    parseFloat(base.providerScores[p.apiProductId]).toFixed(0),
                                    "\u00A3" + (1 * p.price).toFixed(2),
                                    {
                                        BestQuality: bestQuality === parseFloat(base.providerScores[p.apiProductId]),
                                        BestInBudget: budget !== null && budget >= (1 * p.price) && bestQualityInBudget === parseFloat(base.providerScores[p.apiProductId]),
                                        InBudget: budget !== null && budget >= (1 * p.price),
                                        LowestPremium: minPrice === 1 * p.price,
                                        Standard: p.decisionType === "STANDARD" && p.price > 0 ? true : false,
                                        NonStandard: p.decisionType === "NON_STANDARD"? true : false,
                                        Refer: p.decisionType === "REFER"? true : false,
                                        Decline: p.decisionType === "DECLINE" ? true : false,
                                        Postpone: p.decisionType === "POSTPONE" ? true : false,
                                        EvidenceRequired: p.decisionType === "EVIDENCE_REQUIRED" ? true : false,
                                        Exclusion: p.indicativeLoadingContributors != null && p.indicativeLoadingContributors.some(d => !!d.indicativeExclusionContributions || !!d.exclusionContributions)
                                    }
                                ],
                        outlineBoxColor: null,
                        datatableBoxColor: null,
                        Purchasable: p.purchasable
                    }
                });

                return {
                    showLegend: false,
                    max: 100.0,
                    items: helper.groupByArray(data, "Reference")
                };
            },
            PurchasableItems: function () { return { items: helper.groupByArray(this.OverallChartData.items.map(x=> x.values).map(x=> x[0]).filter(x=> x.Purchasable != false), "Reference")}; },
            WeightChartTitle: function () {
                var selection = JSON.parse(this.SelectionAnalysisOption);
                if (selection.cat !== null) {
                    return "Feature Breakdown";
                }
                return "Category Breakdown";
            },
            HasWeightChart: function () {
                if (this.IsPricing) return false;
                var selection = JSON.parse(this.SelectionAnalysisOption);
                if (selection.cat !== null) {
                    var category = this.Analysis.categoryAnalysis[selection.cat];
                    if (selection.feature !== null) {
                        var feature = category.featureAnalysis[selection.feature];
                        return (typeof feature.subFeatureAnalysis) !== "undefined" && feature.subFeatureAnalysis !== null && feature.subFeatureAnalysis.length > 0;
                    }
                    return true; //category analysis always has a weight graph
                }
                return true; //overall always has a weight graph
            },
            WeightChartData: function () {
                var data;
                var thisControl = this;
                var selection = JSON.parse(this.SelectionAnalysisOption);
                if (selection.cat !== null) {
                    var category = this.Analysis.categoryAnalysis[selection.cat];
                    if (selection.feature !== null) {
                        var feature = category.featureAnalysis[selection.feature];
                        data = feature.subFeatureAnalysis.map(function (subfeature) {
                            return {
                                Legend: subfeature.subFeatureName,
                                Value: subfeature.weightingPercentage.toFixed(2) * 1
                            }
                        });
                    }
                    else {
                        data = Object.keys(category.featureAnalysis)
                            .map(function (featureReference) {
                                return {
                                    Legend: thisControl.UserSelection.extendedFeatures.filter(function (ef) { return ef.featureReference == featureReference; })[0].featureName,
                                    Value: category.featureAnalysis[featureReference].featureWeight.toFixed(2) * 1
                                };
                            });
                    }

                }
                else {
                    data = Object.keys(this.Analysis.categoryAnalysis).map(
                        function (category) {
                            return {
                                Legend: category,
                                Value: thisControl.Analysis.categoryAnalysis[category].categoryWeight.toFixed(2) * 1
                            }
                        }
                    );
                }
                data = data.sort(function (a, b) { return b.Value - a.Value; });
                return data;
            },
            SelectedFeatureInAnalysisForSelect: {
                get: function () {
                    var thisControl = this;
                    if (thisControl.SelectFeatureInAnalysis === null)
                        return "[null]";
                    return thisControl.SelectFeatureInAnalysis;
                },
                set: function (setValue) {
                    var thisControl = this;
                    if (setValue === "[null]")
                        thisControl.SelectFeatureInAnalysis = null;
                    else
                        thisControl.SelectFeatureInAnalysis = setValue;
                }
            },
            FeaturesInAnalysisIncludingOverview: function () {
                var thisControl = this;
                var returnedFeatures = thisControl.Analysis === null ? thisControl.DataTableResponse.featureDataTables : thisControl.Analysis.featureAnalysis;
                var result = thisControl.UserSelection.extendedFeatures
                    .filter(function (feature) {
                        return returnedFeatures[feature.featureReference] !== undefined;
                    })
                    .map(function (feature) {
                        return {
                            featureReference: feature.featureReference,
                            featureName: feature.featureName
                        }
                    }).sort(function (a, b) {
                        if (a.featureName < b.featureName)
                            return -1;
                        if (a.featureName > b.featureName)
                            return 1;
                        return 0;
                    });
                return result;
            },
            ComparisonDetails: function () {
                var thisControl = this;

                //thisControl.UserSelection.includedProviders = thisControl.CompareSelection;
                return {
                    selection: thisControl.UserSelection,
                    analysis: thisControl.CurrentAnalysis,
                    firstInsuredName: thisControl.UserSelection.primaryClient.forename + " " + thisControl.UserSelection.primaryClient.surname,
                    secondInsuredName: thisControl.UserSelection.secondaryClient === null ? null : thisControl.UserSelection.secondaryClient.forename + " " + thisControl.UserSelection.secondaryClient.surname,
                    //firstInsuredName: thisControl.UserSelection.primaryClient.title + " " + thisControl.UserSelection.primaryClient.forename + " " + thisControl.UserSelection.primaryClient.surname,
                    //secondInsuredName: thisControl.UserSelection.secondaryClient === null ? null : thisControl.UserSelection.secondaryClient.title + " " + thisControl.UserSelection.secondaryClient.forename + " " + thisControl.UserSelection.secondaryClient.surname,
                    providersInDataTables: thisControl.HasDataTables ? thisControl.UserSelection.includedProviders : null,
                    reportTitle: thisControl.ReportTitle,
                    ShouldIncludeDefinitions: true
                };
            },
            AllUniqueResultProviders() {
                if (!this.AllProducts || this.AllProducts.length === 0) return [];
                return [...new Set(
                    this.AllProducts
                        .map(product => helper.GetProviderLogoByName(product.displayName.trim().toLowerCase()))
                        .filter(Boolean))]
                    .map(name => this.capitalizeWords(name))
                    .sort((a, b) => a.localeCompare(b));
            },
            UncheckedProviders() {
                return this.AllUniqueResultProviders.filter(
                    (provider) => !this.SelectedProviders.includes(provider)
                );
            }
        },
        mounted: function () {
            var thisControl = this;
            thisControl.SelectedProviders = [...this.AllUniqueResultProviders];

            var customerLoaded = function (c) {
                var isClient1 = (
                    c.life1FirstName === thisControl.userSelection.primaryClient.forename
                    && c.life1LastName === thisControl.userSelection.primaryClient.surname
                    && c.life1Gender === helper.GetGender(thisControl.userSelection.primaryClient.classification)
                    && helper.GetDisplayableDate(c.life1DateOfBirth) === helper.GetDisplayableDate(thisControl.userSelection.primaryClient.dateOfBirth)
                )
                if (isClient1) {
                    thisControl.isValidCustomer = true;
                    thisControl.customerType = "PersonOne";
                    if (thisControl.userSelection.secondaryClient !== null) {
                        thisControl.customerType = "Both";
                    }
                }
                var isClient2 = (
                    c.life2FirstName === thisControl.userSelection.primaryClient.forename
                    && c.life2LastName === thisControl.userSelection.primaryClient.surname
                    && c.life2Gender === helper.GetGender(thisControl.userSelection.primaryClient.classification)
                    && helper.GetDisplayableDate(c.life2DateOfBirth) === helper.GetDisplayableDate(thisControl.userSelection.primaryClient.dateOfBirth)
                )
                if (isClient2) {
                    thisControl.isValidCustomer = true;
                    thisControl.customerType = "PersonTwo";
                }
            }
            if (this.UserSelection.PreAnalysis) {
                this.Analysis = this.UserSelection.PreAnalysis;
                delete this.UserSelection.PreAnalysis;
                thisControl.SelectedCustomFilterOptionKeys = [];
                if (thisControl?.Analysis.providerFilters) {
                    for (var f = 0; f < thisControl.Analysis.providerFilters.length; f++) {
                        for (var o = 0; o < thisControl.Analysis.providerFilters[f].providerFilterOptions.length; o++) {
                            thisControl.SelectedCustomFilterOptionKeys.push(thisControl.Analysis.providerFilters[f].providerFilterOptions[o].reference);
                        }
                    }
                }

                this.IsLoading = true;
                fetch("/Customer/" + thisControl.UserSelection.customerReference)
                    .then(function (c) { return c.json() })
                    .then(function (c) {
                        customerLoaded(c);
                        thisControl.IsLoading = false;
                        thisControl.advert = null;
                    }
                    ).catch(function () {
                        thisControl.IsLoading = false;
                        thisControl.advert = null;
                    });

                return;
            }
            this.IsLoading = true;
            this.LoadingDescription = "Just a moment, we are preparing your comparison...";
            var waiting = 3;

            var done = function () {
                thisControl.IsLoading = false;
                thisControl.advert = null;
            };

            var getAnalysis = function () {
                var analysisUrl = "/Api/";
                var request = thisControl.UserSelection;

                $.ajax({
                    type: 'POST',
                    url: analysisUrl,
                    contentType: 'application/json',
                    data: JSON.stringify(request),
                    success: function (response) {
                        console.log("Got Analysis");
                        thisControl.Analysis = response.analysis;
                        thisControl.analysisResponse = response;

                        thisControl.SelectedCustomFilterOptionKeys = [];
                        for (var f = 0; f < thisControl.Analysis?.providerFilters?.length; f++) {
                            for (var o = 0; o < thisControl.Analysis.providerFilters[f].providerFilterOptions.length; o++) {
                                thisControl.SelectedCustomFilterOptionKeys.push(thisControl.Analysis.providerFilters[f].providerFilterOptions[o].reference);
                            }
                        }
                        waiting--;
                        if (waiting === 0) {
                            if (response.creditDeducted) {
                                thisControl.SubscriptionService.update();
                                ElMessage({
                                    message: "Credit Deducted",
                                    type: 'success'
                                });
                            }
                            done();
                        }
                        if (response.url)
                        {
                            window.location.href = "/";
                            return;
                        }
                        if (thisControl.Analysis.analysisReferecnce) {
                            thisControl.$router.push({ name: 'AnalysisPage', params: { customerReference: thisControl.UserSelection.customerReference, analysisReferecnce: thisControl.Analysis.analysisReferecnce } });
                        }
                    },
                    error: function (xhr) {
                        waiting--;
                        if (waiting == 0) {
                            done();

                            var message = xhr.status == 401 || xhr.status == 422 ? xhr.responseText : 'We could not get the values from the integration.';

                            thisControl.$message({
                                message: message,
                                type: 'error',
                                duration: 7000
                            });

                            setTimeout(function () {
                                window.location = "/";
                            }, 7000);

                            return;
                        }
                    }
                });
            };

            getAnalysis();

            fetch("/Customer/" + thisControl.userSelection.customerReference)
                .then(function (c) { return c.json() })
                .then(function (c) {
                    customerLoaded(c);
                    waiting--;
                    if (waiting == 0) {
                        done();
                    }
                }).catch(function () {
                    waiting--;
                    if (waiting == 0)
                        done();
                });

            var adToShow = helper.GetAdvert(this.adverts, "WhenPerformingAnalysis", this.UserSelection);
            if (adToShow !== null) {
                this.advert = adToShow;
                waiting++;
                setTimeout(function () {
                    waiting--;
                    if (waiting == 0)
                        done();
                }, adToShow.minimumDurationInSeconds * 1000);
            }

            $.ajax({
                type: 'GET',
                url: '/api/Journey/Update/' + this.UserSelection.sessionReference + "/" + this.UserSelection.journeyReference + "/50/Income%20Protection%20Analysis%20Screen",
                success: function () {
                    waiting--;
                    if (waiting == 0) {
                        done();
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location = "./Api/signin";
                        return;
                    }
                    waiting--;
                    if (waiting == 0)
                        done();
                    //alert("Problem Getting Report" + xhr.responseText);
                }
            });
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
